import React, { Component, Suspense, lazy } from 'react'
import Sidebar from '../../components/sidebar/Sidebar'
import Helmet from 'react-helmet'
import SuspenseLoader from './../../components/suspense_loader/SuspenseLoader'

import './Players.scss'
import HeaderTitle from '../shared/HeaderTitle'

const NBAPlayers = lazy(() => import('./nba/NBAPlayers'))
const NHLPlayers = lazy(() => import('./nhl/NHLPlayers'))
const MLBPlayers = lazy(() => import('./mlb/MLBPlayers'))
const WNBAPlayers = lazy(() => import('./wnba/WNBAPlayers'))

class Players extends Component {
    render() {
        const { league, sport } = this.props.match.params

        return (
            <div className="Players__cont players">
                <Helmet
                    title={`${league.toUpperCase()} Players - Sportsnet.ca`}
                    link={[
                        {
                            rel: 'canonical',
                            href: `${window.location.origin}/${sport}/${league}/players`,
                        },
                    ]}
                />

                <div className="inner_cont">
                    <div className="left_col">
                        {(league === 'nhl' ||
                            league === 'mlb' ||
                            league === 'nba' ||
                            league === 'wnba') && (
                            <HeaderTitle title={league.toUpperCase() + ' Players'}></HeaderTitle>
                        )}

                        <Suspense fallback={<SuspenseLoader />}>
                            {league === 'nhl' && <NHLPlayers {...this.props} />}
                            {league === 'mlb' && <MLBPlayers {...this.props} />}
                            {league === 'nba' && <NBAPlayers {...this.props} />}
                            {league === 'wnba' && <WNBAPlayers {...this.props} />}
                        </Suspense>
                    </div>

                    <div className="right_col">
                        <Sidebar league={league} />
                    </div>
                </div>
            </div>
        )
    }
}

export default Players
